import { render, staticRenderFns } from "./VisitAnswers.vue?vue&type=template&id=03b1b7e0&scoped=true&"
import script from "./VisitAnswers.vue?vue&type=script&lang=js&"
export * from "./VisitAnswers.vue?vue&type=script&lang=js&"
import style0 from "./VisitAnswers.vue?vue&type=style&index=0&id=03b1b7e0&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b1b7e0",
  null
  
)

export default component.exports